import { countryCodeFromText } from "@loot-os/api-contract";

/**
 * A stored order address's country as an ISO code, or null when it has none. The one reader of
 * an order's country, for the server's address rule, the packing queue and the order page alike.
 *
 * `orders.shipping_address` is unvalidated jsonb in several shapes: Loot OS's own (`country` an
 * ISO code), boxed's (`countryCode` beside `country` as a display name), boxed's older rows (only
 * `country: "United States"`), and a legacy `name/line1/city/state/zip`. boxed's `countryCode`
 * wins; otherwise `country` is read as a code or a name (`countryCodeFromText`, boxed's order).
 * Pure, so the dashboard reads an order's country exactly as the server does.
 */
export function orderAddressCountry(address: unknown): string | null {
  if (typeof address !== "object" || address === null || Array.isArray(address)) return null;
  const fields = address as Record<string, unknown>;
  // Each key checked for content, not presence: `{ country: "", countryCode: "US" }` is US.
  for (const key of ["countryCode", "country"]) {
    const value = fields[key];
    const code = typeof value === "string" ? countryCodeFromText(value) : null;
    if (code) return code;
  }
  return null;
}
